import { getAccessToken } from '../../../auth/tokenStore';
import { useState, useCallback, useEffect, useRef } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, '') || '';
const API_URL  = `${API_BASE}/api/dashboard-preferences/`;

// localStorage keys — used only as a fast local cache (avoids flash on load)
const LS_LAYOUT = 'admin_dashboard_layout_v3';
const LS_HIDDEN = 'admin_dashboard_hidden_v3';
const LS_KPI    = 'admin_hidden_kpis';

// ─── default layouts ─────────────────────────────────────────────────────────

const DEFAULT_LAYOUTS = {
  lg: [
    { i: 'kpi-bento',     x: 0,  y: 0,  w: 12, h: 3, minW: 6, minH: 2 },
    { i: 'chart-certs',   x: 0,  y: 3,  w: 6,  h: 4, minW: 3, minH: 3 },
    { i: 'chart-permits', x: 6,  y: 3,  w: 6,  h: 4, minW: 3, minH: 3 },
    { i: 'activity',      x: 0,  y: 7,  w: 6,  h: 4, minW: 3, minH: 3 },
    { i: 'resource',      x: 6,  y: 7,  w: 6,  h: 4, minW: 4, minH: 3 },
    { i: 'wh-summary',    x: 0,  y: 11, w: 4,  h: 5, minW: 3, minH: 3 },
    { i: 'wh-low-stock',  x: 4,  y: 11, w: 4,  h: 5, minW: 3, minH: 3 },
    { i: 'wh-movements',  x: 8,  y: 11, w: 4,  h: 5, minW: 3, minH: 3 },
    { i: 'wh-top-items',  x: 0,  y: 16, w: 12, h: 4, minW: 4, minH: 3 },
    { i: 'eq-summary',    x: 0,  y: 20, w: 5,  h: 5, minW: 3, minH: 3 },
    { i: 'eq-by-type',    x: 5,  y: 20, w: 7,  h: 5, minW: 3, minH: 3 },
    { i: 'ts-summary',    x: 0,  y: 25, w: 5,  h: 3, minW: 3, minH: 2 },
    { i: 'ts-pending',    x: 5,  y: 25, w: 7,  h: 6, minW: 3, minH: 3 },
    { i: 'wh-assignments',x: 0,  y: 31, w: 6,  h: 5, minW: 3, minH: 3 },
  ],
  md: [
    { i: 'kpi-bento',     x: 0, y: 0,  w: 10, h: 3, minW: 5, minH: 2 },
    { i: 'chart-certs',   x: 0, y: 3,  w: 5,  h: 4, minW: 3, minH: 3 },
    { i: 'chart-permits', x: 5, y: 3,  w: 5,  h: 4, minW: 3, minH: 3 },
    { i: 'activity',      x: 0, y: 7,  w: 5,  h: 4, minW: 3, minH: 3 },
    { i: 'resource',      x: 5, y: 7,  w: 5,  h: 4, minW: 3, minH: 3 },
    { i: 'wh-summary',    x: 0, y: 11, w: 3,  h: 5, minW: 3, minH: 3 },
    { i: 'wh-low-stock',  x: 3, y: 11, w: 4,  h: 5, minW: 3, minH: 3 },
    { i: 'wh-movements',  x: 7, y: 11, w: 3,  h: 5, minW: 3, minH: 3 },
    { i: 'wh-top-items',  x: 0, y: 16, w: 10, h: 4, minW: 4, minH: 3 },
    { i: 'eq-summary',    x: 0, y: 20, w: 5,  h: 5, minW: 3, minH: 3 },
    { i: 'eq-by-type',    x: 5, y: 20, w: 5,  h: 5, minW: 3, minH: 3 },
    { i: 'ts-summary',    x: 0, y: 25, w: 5,  h: 3, minW: 3, minH: 2 },
    { i: 'ts-pending',    x: 5, y: 25, w: 5,  h: 6, minW: 3, minH: 3 },
    { i: 'wh-assignments',x: 0, y: 31, w: 5,  h: 5, minW: 3, minH: 3 },
  ],
  sm: [
    { i: 'kpi-bento',     x: 0, y: 0,  w: 6, h: 3, minW: 3, minH: 2 },
    { i: 'chart-certs',   x: 0, y: 3,  w: 6, h: 4, minW: 3, minH: 3 },
    { i: 'chart-permits', x: 0, y: 7,  w: 6, h: 4, minW: 3, minH: 3 },
    { i: 'activity',      x: 0, y: 11, w: 6, h: 4, minW: 3, minH: 3 },
    { i: 'resource',      x: 0, y: 15, w: 6, h: 4, minW: 3, minH: 3 },
    { i: 'wh-summary',    x: 0, y: 19, w: 6, h: 5, minW: 3, minH: 3 },
    { i: 'wh-low-stock',  x: 0, y: 24, w: 6, h: 5, minW: 3, minH: 3 },
    { i: 'wh-movements',  x: 0, y: 29, w: 6, h: 5, minW: 3, minH: 3 },
    { i: 'wh-top-items',  x: 0, y: 34, w: 6, h: 4, minW: 3, minH: 3 },
    { i: 'eq-summary',    x: 0, y: 38, w: 6, h: 5, minW: 3, minH: 3 },
    { i: 'eq-by-type',    x: 0, y: 43, w: 6, h: 5, minW: 3, minH: 3 },
    { i: 'ts-summary',    x: 0, y: 48, w: 6, h: 3, minW: 3, minH: 2 },
    { i: 'ts-pending',    x: 0, y: 54, w: 6, h: 6, minW: 3, minH: 3 },
    { i: 'wh-assignments',x: 0, y: 60, w: 6, h: 5, minW: 3, minH: 3 },
  ],
  xs: [
    { i: 'kpi-bento',     x: 0, y: 0,  w: 4, h: 3, minW: 2, minH: 2 },
    { i: 'chart-certs',   x: 0, y: 3,  w: 4, h: 4, minW: 2, minH: 3 },
    { i: 'chart-permits', x: 0, y: 7,  w: 4, h: 4, minW: 2, minH: 3 },
    { i: 'activity',      x: 0, y: 11, w: 4, h: 4, minW: 2, minH: 3 },
    { i: 'resource',      x: 0, y: 15, w: 4, h: 4, minW: 2, minH: 3 },
    { i: 'wh-summary',    x: 0, y: 19, w: 4, h: 5, minW: 2, minH: 3 },
    { i: 'wh-low-stock',  x: 0, y: 24, w: 4, h: 5, minW: 2, minH: 3 },
    { i: 'wh-movements',  x: 0, y: 29, w: 4, h: 5, minW: 2, minH: 3 },
    { i: 'wh-top-items',  x: 0, y: 34, w: 4, h: 4, minW: 2, minH: 3 },
    { i: 'eq-summary',    x: 0, y: 38, w: 4, h: 5, minW: 2, minH: 3 },
    { i: 'eq-by-type',    x: 0, y: 43, w: 4, h: 5, minW: 2, minH: 3 },
    { i: 'ts-summary',    x: 0, y: 48, w: 4, h: 6, minW: 2, minH: 4 },
    { i: 'ts-pending',    x: 0, y: 54, w: 4, h: 6, minW: 2, minH: 3 },
    { i: 'wh-assignments',x: 0, y: 60, w: 4, h: 5, minW: 2, minH: 3 },
  ],
  xxs: [
    { i: 'kpi-bento',     x: 0, y: 0,  w: 2, h: 3, minW: 2, minH: 2 },
    { i: 'chart-certs',   x: 0, y: 3,  w: 2, h: 4, minW: 2, minH: 3 },
    { i: 'chart-permits', x: 0, y: 7,  w: 2, h: 4, minW: 2, minH: 3 },
    { i: 'activity',      x: 0, y: 11, w: 2, h: 4, minW: 2, minH: 3 },
    { i: 'resource',      x: 0, y: 15, w: 2, h: 4, minW: 2, minH: 3 },
    { i: 'wh-summary',    x: 0, y: 19, w: 2, h: 5, minW: 2, minH: 3 },
    { i: 'wh-low-stock',  x: 0, y: 24, w: 2, h: 5, minW: 2, minH: 3 },
    { i: 'wh-movements',  x: 0, y: 29, w: 2, h: 5, minW: 2, minH: 3 },
    { i: 'wh-top-items',  x: 0, y: 34, w: 2, h: 4, minW: 2, minH: 3 },
    { i: 'eq-summary',    x: 0, y: 38, w: 2, h: 5, minW: 2, minH: 3 },
    { i: 'eq-by-type',    x: 0, y: 43, w: 2, h: 5, minW: 2, minH: 3 },
    { i: 'ts-summary',    x: 0, y: 48, w: 2, h: 6, minW: 2, minH: 4 },
    { i: 'ts-pending',    x: 0, y: 54, w: 2, h: 6, minW: 2, minH: 3 },
    { i: 'wh-assignments',x: 0, y: 60, w: 2, h: 5, minW: 2, minH: 3 },
  ],
};

const OPTIONAL_PANELS = [
  'wh-summary', 'wh-low-stock', 'wh-movements', 'wh-top-items', 'wh-assignments',
  'eq-summary', 'eq-by-type',
  'ts-summary', 'ts-pending',
];

// ─── localStorage helpers (fast initial render, avoids flash) ─────────────────

const mergeLayouts = (saved) => {
  if (!saved) return DEFAULT_LAYOUTS;
  const merged = {};
  Object.keys(DEFAULT_LAYOUTS).forEach(bp => {
    const savedBp  = saved[bp] || [];
    const savedIds = new Set(savedBp.map(item => item.i));
    const missing  = DEFAULT_LAYOUTS[bp].filter(item => !savedIds.has(item.i));
    merged[bp] = [...savedBp, ...missing];
  });
  return merged;
};

const lsLayouts = () => {
  try { const s = localStorage.getItem(LS_LAYOUT); return s ? mergeLayouts(JSON.parse(s)) : null; } catch { return null; }
};
const lsHidden = () => {
  try { const s = localStorage.getItem(LS_HIDDEN); return s ? JSON.parse(s) : null; } catch { return null; }
};

// ─── save debounce ────────────────────────────────────────────────────────────

const SAVE_DEBOUNCE_MS = 1500;

// ─── hook ─────────────────────────────────────────────────────────────────────

const useAdminDashboardLayout = () => {
  // Start from localStorage cache for instant render
  const [layouts,      setLayouts]      = useState(() => lsLayouts() || DEFAULT_LAYOUTS);
  const [hiddenPanels, setHiddenPanels] = useState(() => lsHidden()  || OPTIONAL_PANELS);
  const [synced,       setSynced]       = useState(false); // true after first API load

  const saveTimerRef = useRef(null);

  // ── helpers ──────────────────────────────────────────────────────────────

  const authHeaders = () => {
    const token = getAccessToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const saveToServer = useCallback((layouts, hiddenPanels) => {
    const payload = { layouts, hiddenPanels };
    // Update localStorage cache immediately
    try {
      localStorage.setItem(LS_LAYOUT, JSON.stringify(layouts));
      localStorage.setItem(LS_HIDDEN, JSON.stringify(hiddenPanels));
    } catch {}
    // Debounce server write to avoid hammering on every drag step
    clearTimeout(saveTimerRef.current);
    saveTimerRef.current = setTimeout(() => {
      axios.put(API_URL, payload, { headers: authHeaders() }).catch(() => {});
    }, SAVE_DEBOUNCE_MS);
  }, []);

  // ── load from server on mount ─────────────────────────────────────────────

  useEffect(() => {
    axios.get(API_URL, { headers: authHeaders() })
      .then(r => {
        const prefs = r.data || {};
        if (prefs.layouts && Object.keys(prefs.layouts).length) {
          const merged = mergeLayouts(prefs.layouts);
          setLayouts(merged);
          try { localStorage.setItem(LS_LAYOUT, JSON.stringify(merged)); } catch {}
        }
        if (Array.isArray(prefs.hiddenPanels)) {
          setHiddenPanels(prefs.hiddenPanels);
          try { localStorage.setItem(LS_HIDDEN, JSON.stringify(prefs.hiddenPanels)); } catch {}
        }
      })
      .catch(() => {})
      .finally(() => setSynced(true));
  }, []); // eslint-disable-line

  // ── layout change (drag / resize) ────────────────────────────────────────

  const onLayoutChange = useCallback((_layout, allLayouts) => {
    setLayouts(allLayouts);
    setHiddenPanels(prev => {
      saveToServer(allLayouts, prev);
      return prev;
    });
  }, [saveToServer]);

  // ── reset to defaults ─────────────────────────────────────────────────────

  const resetLayout = useCallback(() => {
    setLayouts(DEFAULT_LAYOUTS);
    setHiddenPanels(OPTIONAL_PANELS);
    try {
      localStorage.removeItem(LS_LAYOUT);
      localStorage.removeItem(LS_HIDDEN);
    } catch {}
    axios.put(API_URL, { layouts: {}, hiddenPanels: OPTIONAL_PANELS }, { headers: authHeaders() })
      .catch(() => {});
  }, []); // eslint-disable-line

  // ── toggle panel visibility ───────────────────────────────────────────────

  const togglePanel = useCallback((id) => {
    setHiddenPanels(prev => {
      const next = prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id];
      setLayouts(layouts => {
        saveToServer(layouts, next);
        return layouts;
      });
      return next;
    });
  }, [saveToServer]);

  return { layouts, onLayoutChange, resetLayout, hiddenPanels, togglePanel, synced };
};

export default useAdminDashboardLayout;
